import { IntlShape } from 'react-intl';
import isNumber from 'lodash/isNumber';

/**
 * It takes a number and an IntlShape object and returns a string
 * @param {number} price - The price to be formatted.
 * @param {IntlShape} intl - IntlShape
 * @returns A function that takes two arguments, price and intl, and returns a string.
 */
export function formatPrice(price: number, intl: IntlShape): string {
  if (!isNumber(price)) return '';
  return `${price} ${intl.formatMessage({
    id: 'currency.SAR',
  })}`;
}
